<template>
  <div>
    <div class="header">
      <p class="title">
        LEX
      </p>
    </div>
    <div style="padding: 46px 12px 12px">
      <div v-for="channel in orderByChannel(channels)" :key="channel.id">
        <h2 style="padding: 10px 20px">{{ channel.name }}</h2>
        <Row>
          <Col
            span="6"
             v-for="workspace in orderByWorkspace(channel.workspaces)"
             :key="workspace.id"
             v-if="!workspace.config.hide"
            >
            <Card
              style="margin: 6px;"
              >
                <h3 style="padding-bottom: 10px;" :class="{red: workspace.onair}">
                  {{ workspace.name }}
                </h3>
                <div style="height: 24px;">
                  <Tag v-if="workspace.onair" color="red">
                    <Icon type="ios-radio-button-on"></Icon>
                    連携中
                  </Tag>
                </div>
                <div
                  style="padding-top: 12px;"
                  >
                  <Button
                    v-if="workspace.onair"
                    long
                    type="error"
                    style="color: #fff !important"
                    :to="`/dashboard/${channel.id}/${workspace.id}`"
                  >
                    開く
                  </Button>
                  <Button
                    v-else
                    long
                    :to="`/dashboard/${channel.id}/${workspace.id}`"
                  >
                    開く
                  </Button>
                </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  mounted() {
    this.$store.dispatch('loadChannel')
  },
  methods: {
    orderByChannel(channels) {
      return _.orderBy(channels, i => i.config.order)
    },
    orderByWorkspace(workspaces) {
      return _.orderBy(workspaces, i => i.config.order)
    }
  },
  computed: {
    ...mapGetters([
      'channels'
    ])
  }
}
</script>

<style lang="less">
html, body {
  height: 100%;
  background-color: rgb(238, 238, 238)
}
</style>

<style lang="less" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 46px;
  padding: 8px;
  background-color: black;

  .title {
    color: #fff;
    font-weight: bold;
    padding: 2px 24px 3px;
    font-size: 15px;
  }
}

.red {
  color: #f5222d;
}
</style>
